/* ==========================================================================
   Homara Deco - cajon lateral.

   Ahorro: NO sale de original_total_price, que refleja descuentos aplicados
   al carrito. El ahorro de Homara es la diferencia contra el compare at price
   de cada variante, asi que leemos el producto y comparamos linea por linea.

   Orden del resumen:
     ---- linea ----
     Codigo de descuento   +      <- otra etapa
     ---- linea ----
     Descuento      -$X           <- desglose del precio
     Total           $Y
     Aranceles e impuestos...
     [ Finalizar compra ]

   El ancla es el RENGLON DEL TOTAL, encontrado por subcadena y subiendo hasta
   el hijo directo del resumen. No sirve buscar la clase cart__summary-totals
   (no existe en el DOM que renderiza este tema) ni el texto exacto "Total"
   (viene partido en varios nodos con espacios raros).
   ========================================================================== */
(function () {
  var SECCION = 'cart-drawer-section';
  var CLASE_ABIERTO = 'hd-cajon-abierto';
  var cacheProductos = {};

  function plata(centavos) {
    var n = (centavos || 0) / 100;
    try {
      return '$' + n.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function raiz() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function nodosTexto(zona) {
    var caminante = document.createTreeWalker(zona, NodeFilter.SHOW_TEXT, null);
    var lista = [];
    var n;
    while ((n = caminante.nextNode())) lista.push(n);
    return lista;
  }

  function reemplazar(zona, viejo, nuevo) {
    if (!zona) return;
    nodosTexto(zona).forEach(function (nodo) {
      if (nodo.parentElement && nodo.parentElement.closest('.hd-desc, .hd-ahorro')) return;
      if (nodo.nodeValue.indexOf(viejo) !== -1) {
        nodo.nodeValue = nodo.nodeValue.replace(viejo, nuevo);
      }
    });
  }

  /* Sube desde un nodo hasta el hijo directo de zona. */
  function hijoDirecto(nodo, zona) {
    var el = nodo.parentElement;
    while (el && el.parentElement && el.parentElement !== zona) el = el.parentElement;
    return el && el.parentElement === zona ? el : null;
  }

  function filaDelTotal(zona) {
    var nodos = nodosTexto(zona);
    for (var i = 0; i < nodos.length; i++) {
      var nodo = nodos[i];
      if (nodo.parentElement && nodo.parentElement.closest('.hd-desc, .hd-ahorro, details')) continue;

      var t = (nodo.nodeValue || '').trim();
      if (!t || t.indexOf('Total') === -1) continue;

      var fila = hijoDirecto(nodo, zona);
      if (fila) return fila;
    }
    return null;
  }

  function filaDelBoton(zona) {
    var boton = zona.querySelector('[name="checkout"]');
    if (!boton) return null;
    return hijoDirecto(boton, zona);
  }

  /* --- abrir el cajon ---------------------------------------------------- */
  function buscarDisparador() {
    var todos = document.querySelectorAll('button, a');
    for (var i = 0; i < todos.length; i++) {
      var v = todos[i].getAttribute('on:click');
      if (v && v.indexOf('#cart-drawer/open') !== -1) return todos[i];
    }
    return null;
  }

  function abrirCajon() {
    var disparador = buscarDisparador();
    if (disparador) { disparador.click(); return true; }

    var cajon = document.getElementById('cart-drawer');
    if (!cajon) return false;

    if (typeof cajon.open === 'function') { cajon.open(); return true; }
    if (typeof cajon.show === 'function') { cajon.show(); return true; }

    var dialogo = cajon.querySelector('dialog');
    if (dialogo && typeof dialogo.showModal === 'function') {
      if (!dialogo.open) dialogo.showModal();
      return true;
    }
    return false;
  }

  function vigilarApertura() {
    if (!('MutationObserver' in window)) return;

    var cajon = document.getElementById('cart-drawer');
    var dialogo = cajon && cajon.querySelector('dialog');
    if (!dialogo || dialogo.dataset.hdVigilado === '1') return;
    dialogo.dataset.hdVigilado = '1';

    function sincronizar() {
      document.documentElement.classList.toggle(CLASE_ABIERTO, dialogo.hasAttribute('open'));
    }

    new MutationObserver(sincronizar).observe(dialogo, {
      attributes: true,
      attributeFilter: ['open']
    });

    dialogo.addEventListener('close', function () {
      document.documentElement.classList.remove(CLASE_ABIERTO);
    });

    sincronizar();
  }

  /* --- cuanto se ahorra -------------------------------------------------- */
  function traerProducto(handle) {
    if (cacheProductos[handle]) return Promise.resolve(cacheProductos[handle]);

    return fetch(raiz() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var mapa = {};
        (p.variants || []).forEach(function (v) { mapa[v.id] = v.compare_at_price || 0; });
        cacheProductos[handle] = mapa;
        return mapa;
      })
      .catch(function () { cacheProductos[handle] = {}; return {}; });
  }

  function calcularAhorro(carrito) {
    var items = carrito.items || [];
    var handles = [];

    items.forEach(function (it) {
      if (it.handle && handles.indexOf(it.handle) === -1) handles.push(it.handle);
    });

    return Promise.all(handles.map(traerProducto)).then(function () {
      var lista = 0;
      items.forEach(function (it) {
        var mapa = cacheProductos[it.handle] || {};
        var anclaje = mapa[it.id] || 0;
        if (anclaje > it.price) lista += (anclaje - it.price) * it.quantity;
      });

      var codigos = (carrito.original_total_price || 0) - (carrito.total_price || 0);
      if (codigos < 0) codigos = 0;

      return lista + codigos;
    });
  }

  /* --- barra de ahorro --------------------------------------------------- */
  function pintarAhorro(ahorro) {
    var cajon = document.getElementById('cart-drawer');
    if (!cajon) return;

    var panel = cajon.querySelector('.cart-drawer__inner') || cajon.querySelector('dialog');
    if (!panel) return;

    var vieja = panel.querySelector('.hd-ahorro');
    var texto = plata(ahorro);

    if (ahorro <= 0) { if (vieja) vieja.remove(); return; }
    if (vieja && vieja.dataset.hdMonto === texto) return;
    if (vieja) vieja.remove();

    var barra = document.createElement('p');
    barra.className = 'hd-ahorro';
    barra.dataset.hdMonto = texto;

    var punto = document.createElement('span');
    punto.className = 'hd-ahorro__punto';
    punto.setAttribute('aria-hidden', 'true');

    var frase = document.createElement('span');
    frase.appendChild(document.createTextNode('Estás ahorrando '));
    var monto = document.createElement('strong');
    monto.textContent = texto;
    frase.appendChild(monto);
    frase.appendChild(document.createTextNode(' en tu pedido'));

    barra.appendChild(punto);
    barra.appendChild(frase);
    panel.insertBefore(barra, panel.firstChild);
  }

  /* --- linea de descuento, pegada arriba del renglon del Total ----------- */
  function pintarDescuento(ahorro) {
    var zonas = document.querySelectorAll('.cart-drawer__summary, .cart-page__summary');
    var texto = '-' + plata(ahorro);

    zonas.forEach(function (zona) {
      var vieja = zona.querySelector('.hd-desc');

      if (ahorro <= 0) { if (vieja) vieja.remove(); return; }

      // Si ya esta bien puesta con el mismo monto, no tocamos nada.
      if (vieja && vieja.dataset.hdMonto === texto) {
        var siguiente = vieja.nextElementSibling;
        if (siguiente && (siguiente.textContent || '').indexOf('Total') !== -1) return;
      }
      if (vieja) vieja.remove();

      var ancla = filaDelTotal(zona) || filaDelBoton(zona);
      if (!ancla || !ancla.parentNode) return;

      var caja = document.createElement('div');
      caja.className = 'hd-desc';
      caja.dataset.hdMonto = texto;

      var etiqueta = document.createElement('span');
      etiqueta.textContent = 'Descuento';

      var valor = document.createElement('span');
      valor.className = 'hd-desc__val';
      valor.textContent = texto;

      caja.appendChild(etiqueta);
      caja.appendChild(valor);
      ancla.parentNode.insertBefore(caja, ancla);
    });
  }

  /* --- textos del resumen ------------------------------------------------ */
  function renombrarTextos() {
    document.querySelectorAll('details summary').forEach(function (s) {
      if (s.closest('.hd-desc')) return;
      reemplazar(s, 'Descuento', 'Código de descuento');
    });

    document.querySelectorAll('.cart-drawer__summary, .cart-page__summary').forEach(function (z) {
      reemplazar(z, 'Total estimado', 'Total');

      nodosTexto(z).forEach(function (nodo) {
        var v = nodo.nodeValue || '';
        var i = v.indexOf('Los gastos de env');
        if (i !== -1) {
          nodo.nodeValue = v.slice(0, i) + 'Envío gratis a todo el país.';
        }
      });
    });
  }

  /* --- leer el carrito y repintar ---------------------------------------- */
  var repintando = false;

  function repintar() {
    if (repintando) return Promise.resolve();
    repintando = true;

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) { return calcularAhorro(carrito); })
      .then(function (ahorro) {
        renombrarTextos();
        pintarAhorro(ahorro);
        pintarDescuento(ahorro);
      })
      .catch(function () {})
      .then(function () { repintando = false; });
  }

  function refrescarCajon() {
    return fetch(raiz() + '?sections=' + SECCION)
      .then(function (r) { return r.json(); })
      .then(function (datos) {
        var html = datos[SECCION];
        var destino = document.getElementById('shopify-section-' + SECCION);
        if (!html || !destino) return;

        var temp = document.createElement('div');
        temp.innerHTML = html;
        var nuevo = temp.querySelector('#shopify-section-' + SECCION) || temp.firstElementChild;
        if (nuevo) destino.innerHTML = nuevo.innerHTML;

        vigilarApertura();
      });
  }

  /* --- interceptar el formulario del producto ---------------------------- */
  function initFormularios(base) {
    var forms = (base || document).querySelectorAll('.hd-oferta__form');

    forms.forEach(function (form) {
      if (form.dataset.hdAjax === '1') return;
      form.dataset.hdAjax = '1';

      form.addEventListener('submit', function (e) {
        if (typeof window.fetch !== 'function') return;
        e.preventDefault();

        var boton = form.querySelector('[data-hd-agregar]');
        var textoOriginal = boton ? boton.textContent : '';

        if (boton) {
          boton.disabled = true;
          boton.textContent = 'Agregando...';
        }

        function restaurar() {
          if (!boton) return;
          boton.disabled = false;
          boton.textContent = textoOriginal;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add');
            return r.json();
          })
          .then(function () { return refrescarCajon(); })
          .then(function () {
            restaurar();
            if (!abrirCajon()) { window.location.href = '/cart'; return; }
            vigilarApertura();
            return repintar();
          })
          .catch(function () {
            restaurar();
            form.dataset.hdAjax = '0';
            window.location.href = '/cart';
          });
      });
    });
  }

  function vigilarContenido() {
    if (!('MutationObserver' in window)) return;

    var zonas = [
      document.getElementById('shopify-section-' + SECCION),
      document.querySelector('.cart-page__summary')
    ];

    zonas.forEach(function (zona) {
      if (!zona || zona.dataset.hdContenido === '1') return;
      zona.dataset.hdContenido = '1';

      var pendiente;
      new MutationObserver(function () {
        window.clearTimeout(pendiente);
        pendiente = window.setTimeout(repintar, 250);
      }).observe(zona, { childList: true, subtree: true });
    });
  }

  function initTodo(base) {
    try {
      initFormularios(base);
      vigilarApertura();
      vigilarContenido();
      repintar();
    } catch (e) {
      /* nunca tumbamos la pagina por esto */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  } else {
    initTodo();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initTodo(e.target);
  });
})();
